import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/clog/edi/batchdataconfig'
import pathMap from 'src/paths/pathMap'

class BatchDataConfigRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.BATCH_DATA_CONFIG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.BATCH_DATA_CONFIG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.BATCH_DATA_CONFIG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.BATCH_DATA_CONFIG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default BatchDataConfigRoute
